import { createContext, useContext, useState } from "react";


export const AuthContext = createContext()

export const useAuthContext = () => {
    return useContext(AuthContext)  // to use the AuthContext, you must wrap your app with AuthContextProvider and use the useAuthContext hook in your components.  For example: const { authUser } = useAuthContext()  and return <h1>{authUser?.username}</h1>  in your App.js file.  It will return the current authUser if there is one, or null if there isn't.  The authUser will be updated whenever the user logs in or out.  You can use the setAuthUser function to update the user state.  For example, if you call setAuthUser(null) in your LogoutButton component, the user will be logged out and the authUser state will be updated.  The setAuthUser function is provided as a prop to the AuthContextProvider component.  You can use this to update the user state whenever the user logs in or out.  For example, if you call setAuth
}

export const AuthContextProvider = ({ children }) => {
    const [authUser, setAuthUser] = useState(JSON.parse(localStorage.getItem("chat-user")) || null)

    const [menu, setMenu] = useState({
        title: '',
        active: ''
    })

    return <AuthContext.Provider value={{ authUser, setAuthUser, menu, setMenu }}>
        {children}
    </AuthContext.Provider>
}